import React, { useState } from 'react';
import './CustomGeocoder.css';

const CustomGeocoder = ({ mapRef, onSelectLocation }) => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [noResults, setNoResults] = useState(false);

  const handleSearch = async () => {
    if (query.trim() === '') return; // Ensure there's a query to search for

    const response = await fetch(
      `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(query)}&format=geojson&polygon_geojson=1&addressdetails=1`
    );
    const geojson = await response.json();
    const features = geojson.features;

    if (features.length === 0) {
      setNoResults(true);
    } else {
      setNoResults(false);
    }

    setResults(features);
  };

  const handleResultClick = (result) => {
    onSelectLocation(result.geometry);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <div className="geocoder-container">
      <div className="input-container">
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={handleKeyDown}  // Trigger search on Enter key
          placeholder="Search for places"
          className="track-input"
        />
        <button onClick={handleSearch} className="btn btn-primary">
          Search
        </button>
      </div>
      <ul className="results-list">
        {results.length > 0 ? (
          results.map((result, index) => (
            <li
              key={index}
              onClick={() => handleResultClick(result)}
              className="result-item"
            >
              {result.properties.display_name}
            </li>
          ))
        ) : (
          noResults && <li className="result-item">No results found</li>
        )}
      </ul>
    </div>
  );
};

export default CustomGeocoder;
